import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui'
import { actions as operationActions } from 'ducks/uiOperations'
import { actions as formActions } from 'ducks/form'
import { selectors as rfcSelectors, actions as rfcActions } from 'ducks/supplierEnquiry/activity/rfc'
import { fetch } from 'api/supplierEnquiry/activity/rfc'
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters'
import { selectors as supplierSelectors } from 'ducks/supplierEnquiry/supplier';


export const mapStateToProps = state => {
  const params = new URLSearchParams(location.search);

  return {
    gridName: 'SupplierActivityRFCs',
    columnDefs: rfcSelectors.columns(state),
    isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
    gridOptions: rfcSelectors.gridOptions(state),
    filterRow: rfcSelectors.filterRow(state),
    selectedFilters: rfcSelectors.selectedFilters(state),
    appliedFilters: rfcSelectors.filterRow(state) && filterSelectors.getFilters(state, rfcSelectors.filterRow(state).formName),
    reqParams: (supplierSelectors.selected(state) || params.get('Supplier'))
      &&
    {
      SupplierId: (supplierSelectors.selected(state) && supplierSelectors.selected(state).Supplier) || params.get('Supplier')
    },
    apiMethod: supplierSelectors?.selected(state)?.Supplier || params?.get('Supplier') ? fetch : () => Promise.resolve(null)
  }
};

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: rfcActions.setSelected,
  applyFilters: filterActions.applyFilters
}
